import React, { useEffect, useState } from "react";
import PanelCustom from "../../../../features/PanelCustom";
import Basket from "../../Basket";
import { HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight } from "react-icons/hi";
import ButtonCustom from "../../../../features/ButtonCustom/ButtonCustom";
import { BasketItem } from "../../../models/BasketItem";
import WeatherTicket from "../WeatherTicket";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { IconButton } from "@mui/material";
import TooltipCustom from "../../../../features/TooltipCustom";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import { EXERCISE_PAGE, REALIZE_VOUCHER_PAGE, TICKETS_PAGE, ZONES_PAGE } from "../../../routes";
import { useLocation, useNavigate } from "react-router";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import BasketMoreButton from "./BasketMoreButton";
import { TicketAccess } from "../../../models/TicketAccess";
import { isAfternoonTime } from "../../../../utils/isAfternoonTime";
import { BASKET_CALCULATE_PROMOTION, EXERCISE_BASKET_CLEAR } from "../../../api/apiRoutes";
import useApiRequest from "../../../../utils/hooks/useApiRequest";
import useConfigDiscount from "../../../../utils/hooks/useConfigDiscount";
import { REALIZE_VOUCHER } from "../../../models/TypeSale";

interface IProps {
  colorClass: string;
  basket: BasketItem[];
  onRemoveToBasket: (index: number) => void;
  updateBasket: (basket: BasketItem[]) => void;
  onNavigateFinalize: () => void;
  finalizeButtonText: string;
  isSaleWithExercise: boolean;
  disabledFinalizeBtn?: boolean;
  totalListPrice: number;
  isWeatherTicket?: boolean;
  title?: string;
  typeSale?: string;
}

const textTooltip = "Ceny biletów różnią się w zależności od wyboru dnia i przedziału czasowego.";

const LeftContainer: React.FC<IProps> = ({
  colorClass,
  basket,
  onRemoveToBasket,
  updateBasket,
  onNavigateFinalize,
  finalizeButtonText,
  isSaleWithExercise,
  disabledFinalizeBtn = false,
  totalListPrice,
  isWeatherTicket = true,
  title = "Twój Koszyk",
  typeSale
}: IProps) => {
  const total = basket.reduce((acc: number, item: BasketItem) => acc + item.price * item.qnt, 0);
  const showTotal = basket.some((item: BasketItem) => item.showPrice);
  const isDesktop = useDesktopSize();
  const navigate = useNavigate();
  const location = useLocation();
  const { get, post } = useApiRequest();
  const [showBasket, setShowBasket] = useState(false);
  const { DISCOUNT_TEXT } = useConfigDiscount();

  const isBasket = () => {
    if (!isDesktop) {
      return showBasket;
    }
    return true;
  };

  const basketText =
    location.pathname === EXERCISE_PAGE
      ? "Koszyk jest pusty, wróc do sklepu"
      : "Wybierz bilety i kup je szybko i wygodnie!";

  const isPromotionSummary = totalListPrice - total;
  const isPromotionText = basket.some((item: BasketItem) =>
    item.ticketAccess.some((exercise: TicketAccess) => isAfternoonTime("14:00", exercise.startDate))
  );

  useEffect(() => {
    if (basket.length === 0) {
      setShowBasket(false);
    }
  }, [basket]);

  const returnToTicketPage = async () => {
    const { isError } = await post(EXERCISE_BASKET_CLEAR);
    if (!isError) {
      await get(BASKET_CALCULATE_PROMOTION("", true));
    }

    if (location.pathname === EXERCISE_PAGE) {
      if (typeSale === REALIZE_VOUCHER) {
        navigate(`${REALIZE_VOUCHER_PAGE}?isSaleWithExercise=true`);
      } else {
        navigate(`${TICKETS_PAGE}?isSaleWithExercise=${isSaleWithExercise}`);
      }
    } else {
      navigate(`${ZONES_PAGE}`);
    }
  };

  const isBasketLimit = basket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0) > 12;

  return (
    <div className={`left-container ${showBasket && basket.length > 0 ? "class-top-0" : ""}`} id={"basket-panel"}>
      <PanelCustom title={title}>
        {!isDesktop && basket.length > 0 && (
          <div className={"show-basket-mobile"} onClick={() => setShowBasket(!showBasket)}>
            {showBasket ? (
              <BasketMoreButton title={`Zwiń`} Icon={IoIosArrowUp} />
            ) : (
              <BasketMoreButton title={`Pokaż ${basket.length} bilety`} Icon={IoIosArrowDown} />
            )}
          </div>
        )}
        {basket.length > 0 ? (
          <React.Fragment>
            {isBasket() && <Basket colorClass={colorClass} basket={basket} onRemoveToBasket={onRemoveToBasket} />}
            {showTotal && (
              <div className={`summary`}>
                <div className={"summary-total-panel"}>
                  {basket.length > 0 && isPromotionSummary > 0 && (
                    <>
                      {isPromotionText && <p className={"summary-promotion"}>{DISCOUNT_TEXT}</p>}
                      <p className={"summary-total-list-price"}>{totalListPrice.toFixed(2)} zł</p>
                    </>
                  )}
                </div>
                <div className={"summary-basket-total"}>
                  <p className={"summary-text-price"}>Łączna cena: </p>
                  <p className={"summary-price"}>{total.toFixed(2)} zł</p>
                  {isSaleWithExercise && (
                    <TooltipCustom text={textTooltip} placement={"top"}>
                      <IconButton style={{ padding: 0 }}>
                        <AiOutlineQuestionCircle className={`ai-info-circle question-icon-color`} />
                      </IconButton>
                    </TooltipCustom>
                  )}
                </div>
              </div>
            )}
            {isBasketLimit ? (
              <div className={"default-panel"}>
                <p className={"red-class"}>
                  W celu zorganizowania pobytu grupowego prosimy o kontakt z Działem Sprzedaży: tel. +48 22 611 61 22/26
                  , mail: sprzedaz@julinek.com.pl
                </p>
              </div>
            ) : (
              <ButtonCustom
                title={finalizeButtonText}
                className={`button-error-color button-full-width ${disabledFinalizeBtn ? "disabled-error-btn" : ""}`}
                Icon={disabledFinalizeBtn ? null : HiOutlineArrowNarrowRight}
                iconPosition={disabledFinalizeBtn ? "center" : "right"}
                onClick={() => onNavigateFinalize()}
                disabled={disabledFinalizeBtn}
              />
            )}
          </React.Fragment>
        ) : (
          <p className={"default-text"}>{basketText}</p>
        )}
      </PanelCustom>

      {!isDesktop ? (
        <div className={"weather-panel-mobile"}>
          <ButtonCustom
            title={""}
            className={"button-default btn-wide"}
            Icon={HiOutlineArrowNarrowLeft}
            iconPosition={"center"}
            onClick={() => returnToTicketPage()}
          />
          {isWeatherTicket && <WeatherTicket updateBasket={updateBasket} />}
        </div>
      ) : (
        isWeatherTicket && <WeatherTicket updateBasket={updateBasket} />
      )}
    </div>
  );
};

export default LeftContainer;
